(function () {
    'use strict';

    angular
        .module('directives.focusOn', [])
        .directive('focusOn', directive);

    directive.$inject = [];

    function directive() {
        return {
            link: function(scope, elem, attr){
                var on;

                attr.$observe('focusOn', function(value){
                    if (on) {
                        on();
                    }

                    on = scope.$on(value, function() {
                        elem[0].focus();
                    });
                });
            }
        };
    }
})();